import angular from 'angular';
import invisionUiModule from 'invision-ui';
import AdjustmentsDetailsPopout from './adjustment.detail.popout';
export default angular.module('invision.customercare.billingpayments.adjustment.detail.popout', [invisionUiModule]).directive('uiPopoutAdjustments', AdjustmentsDetailsPopout).name;